import * as components from './components'

export default [
  {
    path: '/programguide/test',
    component: components.ProgramGuideTest,
    name: 'programGuideTest',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/home',
    component: components.ProgramGuideDetail,
    name: 'programGuideDetail',
    props: true
  },
  {
    path: '/programguide/upload',
    component: components.ProgramGuideUpload,
    name: 'programGuideUpload',
    props: false
  },
  {
    path: '/programguide/bulkUpload',
    component: components.ProgramGuideBulkUpload,
    name: 'programGuideBulkUpload',
    props: false
  },
  {
    path: '/programguide/list',
    component: components.ProgramGuideList,
    name: 'programGuideList',
    props: false
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/introduction',
    component: components.ProgramGuideIntroduction,
    name: 'programGuideIntroduction',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/careerProspects',
    component: components.ProgramGuideCareerProspects,
    name: 'programGuideCareerProspects',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/degreeRequirements',
    component: components.ProgramGuideDegreeRequirements,
    name: 'programGuideDegreeRequirements',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/concentration',
    component: components.ProgramGuideConcentration,
    name: 'programGuideConcentration',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/concentration/detail',
    component: components.ProgramGuideConcentrationDetail,
    name: 'programGuideConcentrationDetail',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/streams',
    component: components.ProgramGuideStreams,
    name: 'programGuideStreams',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/pathways/detail',
    component: components.ProgramGuidePathwayDetail,
    name: 'programGuidePathwayDetail',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/alumniInsights',
    component: components.ProgramGuideAlumniInsights,
    name: 'programGuideAlumniInsights',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/staff',
    component: components.ProgramGuideStaff,
    name: 'programGuideStaff',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/relatedProgram',
    component: components.ProgramGuideRelatedProgram,
    name: 'programGuideRelatedProgram',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/faq',
    component: components.ProgramGuideFAQ,
    name: 'programGuideFAQ',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/compliance',
    component: components.ProgramGuideCompliance,
    name: 'programGuideCompliance',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/jobs',
    component: components.ProgramGuideJobs,
    name: 'programGuideJobs',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/enrollment',
    component: components.ProgramGuideEnrollment,
    name: 'programGuideEnrollment',
    props: true
  },

  {
    path: '/programguide/:cipCode/:programGuideCode/:type/careers',
    component: components.ProgramGuideCareers,
    name: 'programGuideCareers',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/status',
    component: components.ProgramGuideMyProgramStatus,
    name: 'programGuideMyProgramStatus',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/spotlightAlumni',
    component: components.ProgramGuideSpotlightAlumni,
    name: 'programGuideSpotlightAlumni',
    props: true
  },
  {
    path: '/majorminor/upload',
    component: components.MajorMinorUpload,
    name: 'majorMinorUpload',
    props: true
  },
  {
    path: '/majorminor/list',
    component: components.MajorMinorList,
    name: 'majorMinorList',
    props: true
  },
  {
    path: '/majorminor/edit/:cipCode',
    component: components.MajorMinorEdit,
    name: 'majorMinorEdit',
    props: true
  },
  {
    path: '/majorminor/thumbnail/googleDriveOauth',
    component: components.GoogleDriveOauth,
    name: 'googleDriveOauth',
    props: true
  },
  {
    path: '/alumniInsight/bulkUpload',
    component: components.AlumniInsightBulkUpload,
    name: 'alumniInsightBulkUpload',
    props: false
  }
]



// WEBPACK FOOTER //
// ./src/app/programguide/routes.js